import { NodeDataType } from 'src/modules/network-configuration/models/node-data';

const keywordMap: Array<[NodeDataType, string[]]> = [
  [NodeDataType.Camera, ['camera']],
  [
    NodeDataType.DestinationSign,
    ['destination-sign', 'dest-sign', 'girouette'],
  ],
  [NodeDataType.RouteDisplay, ['route-display', 'screen']],
  [NodeDataType.Validator, ['validator']],
  [NodeDataType.Router, ['router']],
  [NodeDataType.Recorder, ['recorder']],
  [NodeDataType.PCSSensor, ['pcs-sensor', 'passenger-counting-sensor']],
];

export const mapDeviceType = (value?: string): NodeDataType => {
  const normalized = value?.trim().toLowerCase().replace(/ /g, '-');
  if (!normalized) return NodeDataType.GenericDevice;

  const exactMatch = Object.values(NodeDataType).find(
    (type) => type.toLowerCase() === normalized,
  );
  if (exactMatch) return exactMatch;

  const keywordMatch = keywordMap.find(([_, keywords]) =>
    keywords.some((keyword) => normalized.includes(keyword)),
  );
  if (keywordMatch) return keywordMatch[0];

  return NodeDataType.GenericDevice;
};
